import { RefObject } from "react"

const ANIMATION = {
    in: (
        refs:
            | RefObject<HTMLDivElement>
            | RefObject<HTMLDivElement>[]
            | HTMLDivElement
            | HTMLDivElement[],
        preset?: {
            left?: string
            right?: string
            top?: string
            bottom?: string
            immediate?: boolean
            pointerEvent?: boolean
            display?: string
        },
        options?: anime.AnimeAnimParams
    ): anime.AnimeAnimParams => {
        const ret = {
            targets: Array.isArray(refs)
                ? refs[0] instanceof HTMLDivElement
                    ? refs
                    : refs.map((ref) => ref.current)
                : refs instanceof HTMLDivElement
                  ? refs
                  : refs.current,
            opacity: [0, 1],
            translateX: preset?.["left"]
                ? [`-${preset?.["left"]}`, "0"]
                : preset?.["right"]
                  ? [preset?.["right"], "0"]
                  : undefined,
            translateY: preset?.["top"]
                ? [`-${preset?.["top"]}`, "0"]
                : preset?.["bottom"]
                  ? [preset?.["bottom"], "0"]
                  : undefined,
            translateZ:
                preset?.["top"] ||
                preset?.["bottom"] ||
                preset?.["left"] ||
                preset?.["right"]
                    ? [0, 0]
                    : undefined,
            duration: 300,
            easing: "easeOutCubic",
            begin: () => {
                const display = preset?.display
                if (display !== undefined) {
                    if (Array.isArray(refs)) {
                        refs.forEach((ref) => {
                            if (ref instanceof HTMLDivElement) {
                                ref.style.display = display
                            } else if (ref.current)
                                ref.current.style.display = display
                        })
                    } else {
                        if (refs instanceof HTMLDivElement) {
                            refs.style.display = display
                        } else if (refs.current)
                            refs.current.style.display = display
                    }
                }
            },
            complete: () => {
                if (preset?.pointerEvent) {
                    if (Array.isArray(refs)) {
                        refs.forEach((ref) => {
                            if (ref instanceof HTMLDivElement) {
                                ref.style.pointerEvents = "auto"
                            } else if (ref.current)
                                ref.current.style.pointerEvents = "auto"
                        })
                    } else {
                        if (refs instanceof HTMLDivElement) {
                            refs.style.pointerEvents = "auto"
                        } else if (refs.current)
                            refs.current.style.pointerEvents = "auto"
                    }
                }
            },
            ...options,
        }
        if (preset?.immediate) {
            ret.duration = 0
        }
        return ret
    },
    out: (
        refs:
            | RefObject<HTMLDivElement>
            | RefObject<HTMLDivElement>[]
            | HTMLDivElement
            | HTMLDivElement[],
        preset?: {
            left?: string
            right?: string
            top?: string
            bottom?: string
            immediate?: boolean
            pointerEvent?: boolean
            display?: boolean
        },
        options?: anime.AnimeAnimParams
    ): anime.AnimeAnimParams => {
        const ret = {
            targets: Array.isArray(refs)
                ? refs[0] instanceof HTMLDivElement
                    ? refs
                    : refs.map((ref) => ref.current)
                : refs instanceof HTMLDivElement
                  ? refs
                  : refs.current,
            opacity: [1, 0],
            translateX: preset?.["left"]
                ? ["0", `-${preset?.["left"]}`]
                : preset?.["right"]
                  ? ["0", preset?.["right"]]
                  : undefined,
            translateY: preset?.["top"]
                ? ["0", `-${preset?.["top"]}`]
                : preset?.["bottom"]
                  ? ["0", preset?.["bottom"]]
                  : undefined,
            translateZ:
                preset?.["top"] ||
                preset?.["bottom"] ||
                preset?.["left"] ||
                preset?.["right"]
                    ? [0, 0]
                    : undefined,
            duration: 300,
            easing: "easeInCubic",
            ...options,
            begin: (anim) => {
                if (preset?.pointerEvent) {
                    if (Array.isArray(refs)) {
                        refs.forEach((ref) => {
                            if (ref instanceof HTMLDivElement) {
                                ref.style.pointerEvents = "none"
                            } else if (ref.current)
                                ref.current.style.pointerEvents = "none"
                        })
                    } else if (refs instanceof HTMLDivElement) {
                        refs.style.pointerEvents = "none"
                    } else if (refs.current)
                        refs.current.style.pointerEvents = "none"
                }
                options?.begin?.(anim)
            },
            complete: (anim) => {
                const display = preset?.display
                if (display !== undefined) {
                    if (Array.isArray(refs)) {
                        refs.forEach((ref) => {
                            if (ref instanceof HTMLDivElement) {
                                ref.style.display = "none"
                            } else if (ref.current)
                                ref.current.style.display = "none"
                        })
                    } else if (refs instanceof HTMLDivElement) {
                        refs.style.display = "none"
                    } else if (refs.current) refs.current.style.display = "none"
                }
                options?.complete?.(anim)
            },
        }
        if (preset?.immediate) ret.duration = 0
        return ret
    },
}

export default ANIMATION
